import * as React from 'react';
import {Context} from './KeyboardContext';

export default class Keyboard extends React.PureComponent<{
  onEvent: (arg1: KeyboardEvent) => boolean | undefined;
  children: React.ReactElement<any>;
}> {
  static contextType = Context;

  onEvent = (e: KeyboardEvent) => this.props.onEvent(e);

  componentDidMount() {
    // @ts-expect-error [PDTY-2706] - TS2571 - Object is of type 'unknown'.
    this.context.addListener(this.onEvent);
  }

  componentWillUnmount() {
    // @ts-expect-error [PDTY-2706] - TS2571 - Object is of type 'unknown'.
    this.context.removeListener(this.onEvent);
  }

  render() {
    return this.props.children;
  }
}
